import { handleIPFSUpload } from "../api/pinata";
import { showToast } from "./showToast";

export  const handleIPFSUploads = async (images: File[] | null) => {
  try {
    if (!images) {
      return null;
    }
    
    const ipfsData = await Promise.all(
      images.map(async (image) => {
        const data = await handleIPFSUpload(image);
        return data;
      })
    );

    const ipfsHashes = ipfsData.map((item) => item.IpfsHash);
    // console.log(ipfsHashes);

    return ipfsHashes;
  } catch (error) {
    console.log(error);
    showToast("Error uploading images to IPFS", "error");
    throw error; // Rethrow the error to handle it in the calling function
  }
};

export const handleIPFSUploadss = async (images: File | null) => {
  try {
    if (!images) {
      return null;
    }
    const ipfsData = await handleIPFSUpload(images);
    const ipfsHash = ipfsData.IpfsHash;

    // console.log("IPFS Hash:", ipfsHash);

    return ipfsHash;
  } catch (error) {
    console.log(error);
    showToast("Error uploading images to IPFS", "error");
    throw error; // Rethrow the error to handle it in the calling function
  }
};